<template>
  <div id="lifeStyleArticle" class="bg-white">
    <iframe
      ref="articleFrame"
      class="lifeStyleArticleFrame"
      title="Lifestyle article"
      :srcdoc="articleFile"
      @load="detIframeHeight($event)"
    ></iframe>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { detIframeHeight } from '@/utils/common';

export default defineComponent({
  props: {
    articleFile: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      detIframeHeight,
    };
  },
});
</script>
<style lang="scss" scoped>
#lifeStyleArticle {
  width: 100%;
}

.lifestyle-wrapper table ul {
  margin: revert !important;
  padding: revert !important;
}

.lifeStyleArticleFrame {
  width: 100%;
  border: 0;
  display: block;
}
</style>
